import React from 'react'
import leftArrow from 'assets/left-arrow.svg'
import rightArrow from 'assets/right-arrow.svg'
import { QuizProgressStatus } from './quiz.types'
import {
  ProgressBar,
  ProgressBars,
  ProgressContainer,
  ProgressLabel,
  ProgressScore,
  QuestionNavButton,
  QuestionNavGroup
} from './QuizModal.styles'

interface QuizProgressHeaderProps {
  currentLabel: string
  percentageLabel: string
  progressStatuses: QuizProgressStatus[]
  variant?: 'header' | 'body'
  showCorrectSuffix?: boolean
  showNavigation?: boolean
  canGoBack?: boolean
  canGoForward?: boolean
  previousQuestionLabel?: string
  nextQuestionLabel?: string
  onGoBack?: () => void
  onGoForward?: () => void
}

const QuizProgressHeader: React.FC<QuizProgressHeaderProps> = ({
  currentLabel,
  percentageLabel,
  progressStatuses,
  variant = 'body',
  showCorrectSuffix = false,
  showNavigation = false,
  canGoBack = false,
  canGoForward = false,
  previousQuestionLabel = 'Previous question',
  nextQuestionLabel = 'Next question',
  onGoBack,
  onGoForward
}) => (
  <ProgressContainer>
    {showNavigation ? (
      <QuestionNavGroup>
        <QuestionNavButton
          type='button'
          $isActive={canGoBack}
          disabled={!canGoBack}
          aria-label={previousQuestionLabel}
          onClick={onGoBack}
        >
          <img src={leftArrow} alt='' aria-hidden='true' />
        </QuestionNavButton>
        <ProgressLabel variant={variant}>{currentLabel}</ProgressLabel>
        <QuestionNavButton
          type='button'
          $isActive={canGoForward}
          disabled={!canGoForward}
          aria-label={nextQuestionLabel}
          onClick={onGoForward}
        >
          <img src={rightArrow} alt='' aria-hidden='true' />
        </QuestionNavButton>
      </QuestionNavGroup>
    ) : (
      <ProgressLabel variant={variant}>{currentLabel}</ProgressLabel>
    )}
    <ProgressBars>
      {progressStatuses.map((status, index) => (
        <ProgressBar key={`quiz-progress-${index}`} status={status} />
      ))}
    </ProgressBars>
    <ProgressScore variant={variant}>
      {showCorrectSuffix ? `${percentageLabel} correct` : percentageLabel}
    </ProgressScore>
  </ProgressContainer>
)

export default QuizProgressHeader
